import { render, staticRenderFns } from "./LpuInterview.vue?vue&type=template&id=55afc297&scoped=true&"
import script from "./LpuInterview.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuInterview.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuInterview.vue?vue&type=style&index=0&id=55afc297&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55afc297",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55afc297')) {
      api.createRecord('55afc297', component.options)
    } else {
      api.reload('55afc297', component.options)
    }
    module.hot.accept("./LpuInterview.vue?vue&type=template&id=55afc297&scoped=true&", function () {
      api.rerender('55afc297', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuInterview/LpuInterview.vue"
export default component.exports